<template>
  <div>
    <div class="row mt-2 mb-4">
      <div class="d-none d-md-block col-md-2">
        <span class="i-account-profile-image-placeholder" style="width: 100%; height: 100%;"></span>
      </div>
      <div class="col-md-5">
        <p>{{$t('people_manager.table.title')}}: <span class="is-bold">{{patient.title ? patient.title : "N/A"}}</span></p>
        <p>{{$t('people_manager.table.name')}}: <span class="is-bold">{{handlePatientName()}}</span></p>
        <p>{{$t('people_manager.table.birthdate')}}: <span class="is-bold">{{patient.birthdate | parseBirthdate}}</span></p>
        <p>{{$t('people_manager.table.gender')}}: <span class="is-bold">{{ patient.gender ? $t(`genders.${patient.gender.toLowerCase()}`) : "N/A"}}</span></p>
        <p>{{$t('people_manager.table.phone')}}: <span class="is-bold">{{patient.mobilePhone === null || patient.mobilePhone === '' ? "N/A" : patient.mobilePhone}}</span></p>
        <p>{{$t('people_manager.table.email')}}: <span class="is-bold">{{patient.email === null || patient.email === '' ? "N/A" : patient.email}}</span></p>
        <p>{{$t('people_manager.table.address')}}: <span class="is-bold">{{ handleAddress() }} </span></p>

      </div>
      <div class="col-md-5">
        <p>{{$t('people_manager.health_nr')}}: <span class="is-bold">{{patient.healthNr || "N/A"}}</span></p>
        <p>{{$t('people_manager.tax_nr')}}: <span class="is-bold">{{patient.taxNr || "N/A"}}</span></p>
        <p>{{$t('people_manager.table.originEntity')}}: <span class="is-bold">{{handlePatientEntity()}}</span></p>
        <p>{{$t('people_manager.table.originFacility')}}: <span class="is-bold">{{handlePatientFacility()}}</span></p>
        <p>{{$t('people_manager.table.country')}}: <span class="is-bold">{{patient.country ? countries.find(elem => elem.code === patient.country.toUpperCase()).name : "N/A"}}</span></p>
        <p></p>
      </div>
    </div>
  </div>

</template>

<script>
import moment from 'moment/moment';
import * as countries from 'i18n-iso-countries'
import Vue from 'vue';

export default {
  props: {
    patient: {
      type: Object,
      required: true
    },
    patientEntity: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {

    }
  },
  methods: {
    handlePatientName: function () {
      var str = ''
      if(this.patient && this.patient.firstName) {
        str += this.patient.firstName
        if (this.patient.lastName) {
          str += ' '+this.patient.lastName
        }
      }
      return str
    },
    handlePatientEntity: function() {
      if (!this.patientEntity) {
        return "N/A"
      }
      return this.patientEntity.name || "N/A"
    },
    handlePatientFacility: function() {
      if(!this.patientEntity || (this.patientEntity && this.patientEntity.facilities.length === 0)) {
        return "N/A"
      }
      const facility = this.patientEntity.facilities.find(facility => facility.id === parseInt(this.patient.originFacilityId))
      if(!facility) {
        return "N/A"
      }
      return facility.name || "N/A"
    },
    handleAddress: function() {
      let addressStr = ''
      if (this.patient && this.patient.addressLine) {
        addressStr += this.patient.addressLine + " "
      }
      if(this.patient.country.toLowerCase() === 'pt') {
        if(this.patient.concelho) {
          addressStr += this.patient.concelho.name
        }
        if(this.patient.concelho && this.patient.concelho.distrito) {
          addressStr += ', '+this.patient.concelho.distrito.name + ' '
        } else {
          addressStr +=' '
        }
      } else {
        if(this.patient && this.patient.county) {
          addressStr += this.patient.county + " "
        }
      }

      if(this.patient && this.patient.postalCode) {
        addressStr += this.patient.postalCode + " "
      }

      return addressStr === '' ? "N/A" : addressStr
    }
  },
  filters: {
    parseBirthdate: function (value) {
      if (!value || value === '') return ''
      let date = moment(value, 'YYYY-MM-DD HH:mm:ss')
      return date.isValid() ? date.format('DD/MM/YYYY') : ''
    }
  },
  computed: {
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        } else if (code.toLowerCase() === 'cz') {
          code = 'cs'
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let vueI18nLocale = Vue.i18n.locale().toLowerCase()
      switch (vueI18nLocale) {
        case 'gb':
          vueI18nLocale = 'en'
          break;
        case 'cz':
          vueI18nLocale = 'cs'
          break;
      }
      let tempCountries = countries.getNames(vueI18nLocale)
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
      //return CountryList.filter(country => this.$store.state.countries.allowed.includes(country.code))
      //return CountryList
    },
  }
};
</script>

<style scoped lang="scss">

</style>
